import { useState } from 'react';
import {
  Command,
  CommandGroup,
  CommandItem,
  CommandList
} from '@/components/ui/command';
import {
  Popover,
  PopoverContent,
  PopoverTrigger
} from '@/components/ui/popover';
import { FILTER_OPERATORS, type FilterOperator } from './types';

type FilterOperatorSelectProps = {
  value: FilterOperator;
  onChange: (operator: FilterOperator) => void;
};

export const FilterOperatorSelect = ({
  value,
  onChange
}: FilterOperatorSelectProps) => {
  const [open, setOpen] = useState(false);

  const current = FILTER_OPERATORS.find(op => op.value === value);

  return (
    <Popover onOpenChange={setOpen} open={open}>
      <PopoverTrigger asChild>
        <button
          className="flex h-full items-center px-2 text-muted-foreground hover:bg-accent hover:text-accent-foreground"
          type="button"
        >
          {current?.label ?? value}
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-40 p-0">
        <Command className="border-none shadow-none">
          <CommandList>
            <CommandGroup>
              {FILTER_OPERATORS.map(op => (
                <CommandItem
                  key={op.value}
                  onSelect={() => {
                    onChange(op.value);
                    setOpen(false);
                  }}
                >
                  <span className={op.value === value ? 'font-medium' : ''}>
                    {op.label}
                  </span>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
